export const F_PUBLIC = 2 ** 0
export const F_PROTECTED = 2 ** 1
export const F_RATING_SYSTEM = 2 ** 4
export const F_VERSION_SELECTOR = 2 ** 5

export interface IAccessState {
  featureFlags: {
    data: {
      flags: {
        [key: string]: {
          is_active: boolean
        }
      },
      switches: {
        [key: string]: {
          is_active: boolean
        }
      },
    }
  }
  common: {
    data: {
      config: IConfig | undefined,
    }
  }
}


export const userLevelSelector = ({
  featureFlags,
  common,
}: { featureFlags: IAccessState['featureFlags'], common: IAccessState['common']}): number => {
  const showRatingSystem = (featureFlags?.data && featureFlags.data.switches?.app_dir_rating?.is_active) || false
  const showVersionSelector = (common?.data?.config?.token?.is_staff && common?.data?.config?.ASP_TESTBED === 'True') || false
  const basePermissions = F_PROTECTED
  const ratingSystemPermissions = showRatingSystem ? F_RATING_SYSTEM : F_RATING_SYSTEM
  const additionalPermissions = showVersionSelector ? F_VERSION_SELECTOR : F_PUBLIC

  const permissionsArray = [
    additionalPermissions,
    basePermissions,
    ratingSystemPermissions,
  ]

  return permissionsArray.reduce((level, flag) => level | flag, F_PUBLIC)
}
